import validate from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/node_modules/nuxt/dist/pages/runtime/validate.js";
import initial_45auth_45global from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/middleware/initialAuth.global.js";
import preserve_45tg_45hash_45global from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/middleware/preserve-tg-hash.global.ts";
import manifest_45route_45rule from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  initial_45auth_45global,
  preserve_45tg_45hash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}